import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          meta: {
            // PATCH ZERA: agente comum pode criar etiqueta (nao editar/apagar - ver Index.vue e
            // label_policy.rb). Sem 'agent' aqui a Lauren nem chega na tela, mesmo com o backend
            // liberado - o guard de rota bloqueia antes do redirect pra labels_list acontecer.
            permissions: ['administrator', 'agent'],
          },
          redirect: to => {
            return { name: 'labels_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'labels_list',
          meta: {
            featureFlag: FEATURE_FLAGS.LABELS,
            // PATCH ZERA: ver comentario em labels_wrapper acima.
            permissions: ['administrator', 'agent'],
          },
          component: Index,
        },
      ],
    },
  ],
};
